module.exports = __webpack_public_path__ + "static/simplex-notification-icon-c1fc9544e7ee2c5ba7f3c1a682151735.svg";